import { Routes, mapToCanActivate, mapToResolve } from '@angular/router';
import { LocationGuard } from '@next/core-lib/relationships';

import { Observable } from 'rxjs';

import { TailBitingDetailComponent } from './components/tail-biting-detail/tail-biting-detail.component';
import { TailBitingOverviewComponent } from './components/tail-biting-overview/tail-biting-overview.component';
import { TailBitingGuard } from './guards/tail-biting.guard';
import { TailBitingResolver } from './resolvers/tail-biting.resolver';

export const TailBitingRoutes = (): Routes => [
  {
    path: '',
    component: TailBitingOverviewComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    resolve: {
      data: mapToResolve<Observable<boolean>>(TailBitingResolver),
    },
  },
  {
    path: 'create/:locationId',
    component: TailBitingDetailComponent,
    canActivate: mapToCanActivate([TailBitingGuard]),
  },
  {
    path: 'edit/:id',
    component: TailBitingDetailComponent,
    canActivate: mapToCanActivate([TailBitingGuard]),
  },
];
